import { ITERABLE_API_DOCS_URL } from 'constants/urls';
import { NavbarOption } from '../types';

export const SUPPORT_LINKS: NavbarOption[] = [
  {
    isExternal: true,
    href: 'https://support.iterable.com/',
    title: 'Knowledge base',
  },
  {
    isExternal: true,
    href: 'https://support.iterable.com/requests/new',
    title: 'Submit a ticket',
  },
  {
    isExternal: true,
    href: 'https://academy.iterable.com/',
    title: 'Iterable Academy',
  },
  {
    isExternal: true,
    href: ITERABLE_API_DOCS_URL,
    title: 'API documentation',
  },
  {
    isExternal: true,
    href: 'https://community.iterable.com',
    title: 'Community',
    hideFromProspect: true,
  },
  {
    isExternal: true,
    href: 'https://status.iterable.com/',
    title: 'Service status',
  },
];

export const BOSS_MANAGE_LINKS: NavbarOption[] = [
  {
    title: 'All projects',
    href: '/settings/projects',
  },
  {
    title: 'All orgs',
    href: '/settings/orgs',
  },
  {
    title: 'All enabled accounts',
    href: '/settings/allEnabledAccounts',
  },
  {
    title: 'All jobs',
    href: '/jobs/manage',
    // NOTE: the manage jobs route isn't actual an "external" link, but
    // we need to do a hard refresh for this route because the route requires
    // something to function that only occurs when the backend route is loaded.
    // once that functionality is fixed, this can be removed
    isExternal: true,
  },
  {
    title: 'Builder templates',
    href: '/templates/builder-templates/manage',
  },
  {
    title: 'Generate demo data',
    href: '/admin/manageDemo',
  },
  {
    title: 'New organization',
    href: '/admin/newOrganization',
  },
];

export const BOSS_MONITOR_LINKS: NavbarOption[] = [
  {
    title: 'Internal metrics',
    href: '/i/metrics',
  },
  // { title: 'Workflow visitors', href: '/' },
];
